// extracted by mini-css-extract-plugin
module.exports = {"title":"CategoryBlock_title__4PV5l","cardsGrid":"CategoryBlock_cardsGrid__3aP9h"};